import { create as createActiveQuotePageComponent } from "./QuoteCart/jspComponents/ActiveQuotePageComponent";
import { createCheckoutPage as createCheckoutDisplayComponent } from "./pages/CheckoutPage";
import { createOrderConfirmationPage } from "~/feature/cart/cart/jspComponents/OrderConfirmationPageComponent";
import { createQuoteConfirmationPage } from "~/feature/cart/cart/jspComponents/QuoteConfirmationPageComponent";
import { create as createConfirmationModalComponent } from "./jspComponents/ConfirmationModalComponent";
import { create as createNavigation } from "./Header/jspComponents/Navigation";
import { createOrderDetailsPage } from "./OrdersQuotes/OrderDetailsPage/OrderDetailsPage";
import { create as createOrderHistoryDisplayComponent } from "./OrdersQuotes/OrderListPage/OrderListPageComponent";
import { createProductDetailsPage } from "./ProductDetails/ProductDetailsPage";
import { create as createToastMessage } from "./jspComponents/ToastMessageComponent";
import { create as createPrimaryLinkButtonComponent } from "./jspComponents/PrimaryLinkButtonComponent";
import { createHeaderNavigation } from "./Header/jspComponents/HeaderNavigationComponent";
import { create as createUserAccountsComponent } from "./UserAccounts/jspComponents/UserAccountsComponent";
import { create as createEditUserAccountsComponent } from "./UserAccounts/jspComponents/EditUserAccountsComponent";
import { createBearingFrequencyCalculatorPage } from "./BearingFrequencyCalculator/BearingFrequencyCalculatorPage";

import { createExporedPasswordChangePage as createExpiredPasswordChangePage } from "./Login/jspComponents/ExpiredPasswordChangePage";
import { createResetPasswordPage } from "./Login/jspComponents/ResetPasswordPage";
import { createChangePasswordPage } from "./Login/jspComponents/ChangePasswordPage";

import { create as createButton } from "./jspComponents/Button";

import { registerComponentFactory } from "./utils/componentRegistry";
import { createABMonitorPage } from "./ABMonitor/components/ABMonitorPage";
import { createAccountSelectionPageComponent } from "./AccountSelection/AccountSelectionPage";
import { createContactUsPage } from "./ContactUs/components/ContactUsPage";
import { createContactUsConfirmationPage } from "./ContactUs/components/ContactUsConfirmationPage";
import { createSavedConfigurationsPage } from "~/Configurators/SavedConfigurationsPage/SavedConfigurationsPage";
import { createNavigationBreadcrumbs } from "./jspComponents/Breadcrumbs/NavigationBreadcrumbs";
import { InquirySuccessPage } from "./InquirySuccess/components/InquirySuccessPage";
import { createMyAccount } from "./MyAccount/MyAccountContainer";
import { createLinearRequestQuoteSuccessPage } from "./Configurators/Linear/components/LinearRequestQuoteSuccessPage";
import { createSelectionAssistant } from "./BearingSelectionAssistant/BearingSelectionAssistant";
import { createHousingSelectionAssistant } from "./HousingSelectionAssistant/HousingSelectionAssistant";
import { createSTCfinderPage } from "./STCfinder/STCfinder";
import { createSalesPartnerPage } from "./SalesPartner/components/SalesPartnerPage";
import { createRegisterFreeSuccessPage } from "./RegisterFreeSuccessPage/RegisterFreeSuccessPage";
import { createCompleteRegistrationContainer } from "./CompleteRegistration/CompleteRegistrationPage";
import { createForkPageNavigation } from "./ForkPage/ForkPageNavigation";
import { createCMSComponent } from "./CMSComponents/componentFactory";
import { createAffiliateSalesPartnerBanner } from "./feature/Affiliate/components/AffiliateSalesPartnerBanner/AffiliateSalesPartnerBanner";
import { createAffiliateSalesPartnerPopup } from "./feature/Affiliate/components/AffiliateSalesPartnerPopup/AffiliateSalesPartnerPopup";
import { createAccountSettings } from "./AccountSettings/AccountSettingsContainer";
import { createOrderQuoteSettings } from "./OrderQuoteSettings/OrderQuoteSettingsContainer";
import { createBrowserNotSupportedPopup } from "./BrowserNotSupported/BrowserNotSupportedPopup";
import { createRegionSelectionBanner } from "./RegionSelectionBanner/RegionSelectionBanner";
import { createProductComparisonPage } from "./ProductComparison/ProductComparisonPage";
import { createShareLinearConfigurationConfirmationPage } from "./Configurators/Linear/components/ShareLinearConfigurationsConfirmationPage";
import { createConfiguratorPage } from "./Configurators/createConfiguratorPage";
import { createShareWishlistConfirmationPage } from "./Wishlist/page/ShareWishlistConfirmationPage";
import { createModalServiceRoot } from "./AddToCart/ModalSevice";
import { NotificationsPage } from "./Notifications/NotificationsPage/NotificationsPage";
import { createNotificationSettingsPage } from "./Notifications/NotificationSettingsPage/NotificationSettingsPage";
import { createBottomNavigation } from "~/common/components/BottomNavigation/BottomNavigation";
import { createRecentlyViewedProductsComponent } from "~/common/components/RecentlyViewedProducts/RecentlyViewedProducts";
import { createHeaterSelectionAssistantComponent } from "~/HeaterSelectionAssistant/HeaterSelectionAssistant";
import { createSchaefflerCADFileSearchComponent } from "~/common/components/SchaefflerCADFileSearchComponent/SchaefflerCADFileSearchComponent";
import { createGearboxSelectionAssistantPage } from "~/GearboxSelectionAssistant/GearboxSelectionAssistant.page";
import { createScanDMCPage } from "~/ScanDMC/ScanDMC";
import { createProductListPage } from "~/Search/pages/ProductListPage/ProductListPage";
import { createSearchPage } from "~/Search/pages/SearchPage/SearchPage";
import { createPageFooter } from "~/common/components/PageFooter/PageFooter";
import { createSalesCampaignPage } from "./SalesCampaign/SalesCampaignPage";
import { createWishlistPage } from "~/Wishlist/page/WishlistPage/WishlistPage";
import { createCartPage } from "~/pages/CartPage";
import { createB2CRequestPage } from "~/pages/B2CRequestPage";
import { createSchaefflerTopBannerComponent } from "~/CMSComponents/components/SchaefflerTopBannerComponent";
import { createQuoteDetailsPage } from "~/OrdersQuotes/QuoteDetailsPage/components/v2/QuoteDetailsPage";
import { createQuoteListPage as createQuoteListDisplayComponent } from "~/OrdersQuotes/QuoteListPage/QuoteListPage";
import { FreeCapacityCockpitPage } from "~/FreeCapacityPush/FreeCapacityPushPage";
import { ContractOverviewPage } from "~/Contracts/components/ContractOverview/ContractOverviewPage";
import { creatContractDetailsPage as createContractDetailsPageComponent } from "~/Contracts/components/ContractDetails/ContractDetailsPage";
import { createRequestContractPage as createContractPageComponent } from "~/Contracts/components/CreateContract/CreateContract";
import { createDataSheetPage } from "~/DataSheetPage/DataSheetPage";
import { LubricationSelectionAssistantPage } from "~/LubricationSelectionAssistant/LubricationSelectionAssistantPage";
import { RegisterForFreePage } from "~/RegisterForFreePage/RegisterForFreePage";
import { CustomerRegistrationPage } from "~/RegisterForFreePage/components/CustomerRegistrationPage/CustomerRegistrationPage";
import { createSchaefflerFccRecommendationComponent } from "./feature/SaleRecommendations/FCCRecommendationsSection/SchaefflerFCCGapProductsRecommendationComponent";
import { createMediaLibraryPage } from "./MediaLibrary/components/MediaLibraryPage";

export const registerComponents = () => {
  registerComponentFactory("AccountSelectionPageComponent", createAccountSelectionPageComponent);
  registerComponentFactory("ActiveQuotePageComponent", createActiveQuotePageComponent);
  registerComponentFactory("CartDisplayComponent", createCartPage);
  registerComponentFactory("CheckoutDisplayComponent", createCheckoutDisplayComponent);
  registerComponentFactory("OrderConfirmationPageComponent", createOrderConfirmationPage);
  registerComponentFactory("QuoteConfirmationPageComponent", createQuoteConfirmationPage);
  registerComponentFactory("ConfirmationModalComponent", createConfirmationModalComponent);
  registerComponentFactory("ContactUsDisplayComponent", createContactUsPage);
  registerComponentFactory("ContactUsConfirmationComponent", createContactUsConfirmationPage);
  registerComponentFactory("Navigation", createNavigation);
  registerComponentFactory("OrderDetailsDisplayComponent", createOrderDetailsPage);
  registerComponentFactory("OrderHistoryDisplayComponent", createOrderHistoryDisplayComponent);
  registerComponentFactory("QuoteDetailsDisplayComponent", createQuoteDetailsPage);
  registerComponentFactory("QuoteListDisplayComponent", createQuoteListDisplayComponent);

  registerComponentFactory("WishlistPageComponent", createWishlistPage);
  registerComponentFactory("lsaPage", () => <LubricationSelectionAssistantPage />);
  registerComponentFactory("ShareWishlistConfirmationPage", createShareWishlistConfirmationPage);

  registerComponentFactory("BearingFrequencyCalculatorComponent", createBearingFrequencyCalculatorPage);
  registerComponentFactory("NotificationsPageComponent", () => <NotificationsPage />);
  registerComponentFactory("NotificationSettingsPageComponent", createNotificationSettingsPage);

  registerComponentFactory("ProductComparison", createProductComparisonPage);
  registerComponentFactory("ContractOverviewDisplayComponent", () => <ContractOverviewPage />);
  registerComponentFactory("ContractDetailsPageComponent", createContractDetailsPageComponent);
  registerComponentFactory("CreateContractPageComponent", createContractPageComponent);
  registerComponentFactory("ProductDetailsPage", createProductDetailsPage);
  registerComponentFactory("ToastMessage", createToastMessage);
  registerComponentFactory("PrimaryLinkButtonComponent", createPrimaryLinkButtonComponent);
  registerComponentFactory("HeaderNavigation", createHeaderNavigation);
  registerComponentFactory("UserAccountsComponent", createUserAccountsComponent);
  registerComponentFactory("EditUserAccountsComponent", createEditUserAccountsComponent);

  registerComponentFactory("ExpiredPasswordChangePage", createExpiredPasswordChangePage);
  registerComponentFactory("ResetPasswordPage", createResetPasswordPage);
  registerComponentFactory("ChangePasswordPage", createChangePasswordPage);

  registerComponentFactory("Button", createButton);

  registerComponentFactory("SelectionAssistantPage", createSelectionAssistant);
  registerComponentFactory("HousingSelectionAssistantPage", createHousingSelectionAssistant);

  registerComponentFactory("ABMonitorPage", createABMonitorPage);
  registerComponentFactory("LinearConfigurator", createConfiguratorPage);
  registerComponentFactory("SavedConfigurationsPage", createSavedConfigurationsPage);
  registerComponentFactory("Breadcrumbs", createNavigationBreadcrumbs);

  registerComponentFactory("PublicRegistrationPage", (props) => <RegisterForFreePage {...props} />);
  registerComponentFactory("SelfRegistrationPage", (props: string) => (
    <CustomerRegistrationPage {...JSON.parse(props)} />
  ));
  registerComponentFactory("ConfirmationPage", createRegisterFreeSuccessPage);
  registerComponentFactory("CompletePublicRegistrationPage", createCompleteRegistrationContainer);

  registerComponentFactory("SalesPartnerWishlistConfirmationPage", (props) => <InquirySuccessPage {...props} />);
  registerComponentFactory("StoreFinderComponent", createSalesPartnerPage);
  registerComponentFactory("MediaLibrary", createMediaLibraryPage);
  registerComponentFactory("STCfinderPageComponent", createSTCfinderPage);
  registerComponentFactory("MyAccountPage", createMyAccount);
  registerComponentFactory("AccountSettingsPage", createAccountSettings);
  registerComponentFactory("OrderQuoteSettingsPage", createOrderQuoteSettings);

  registerComponentFactory("LinearRequestQuoteSuccessPage", createLinearRequestQuoteSuccessPage);
  registerComponentFactory("ShareLinearConfigurationConfirmationPage", createShareLinearConfigurationConfirmationPage);

  registerComponentFactory("ForkPageNavigationComponent", createForkPageNavigation);

  registerComponentFactory("AffiliateSalesPartnerPopup", createAffiliateSalesPartnerPopup);
  registerComponentFactory("AffiliateSalesPartnerBanner", createAffiliateSalesPartnerBanner);

  registerComponentFactory("BrowserNotSupportedPopup", createBrowserNotSupportedPopup);

  registerComponentFactory("RegionSelectionBanner", createRegionSelectionBanner);

  registerComponentFactory("BottomNavigationComponent", createBottomNavigation);

  registerComponentFactory("B2CRequestPage", createB2CRequestPage);

  // CMS Components
  registerComponentFactory("CMSComponent", createCMSComponent);
  registerComponentFactory("CMSColumnLinks", createCMSComponent);
  registerComponentFactory("CMSAccordionContainer", createCMSComponent);
  registerComponentFactory("CMSAccordion", createCMSComponent);
  registerComponentFactory("CMSTable", createCMSComponent);
  registerComponentFactory("CMSHomepagePersonalization", createCMSComponent);
  registerComponentFactory("CMSChipLink", createCMSComponent);

  registerComponentFactory("ModalServiceRoot", createModalServiceRoot);

  registerComponentFactory("RecentlyViewedProductsComponent", createRecentlyViewedProductsComponent);

  registerComponentFactory("HeaterSelectionAssistant", createHeaterSelectionAssistantComponent);

  registerComponentFactory("SchaefflerCADFileSearchComponent", createSchaefflerCADFileSearchComponent);
  registerComponentFactory("GearboxSelectionAssistantPage", createGearboxSelectionAssistantPage);
  registerComponentFactory("ScanDMCPage", createScanDMCPage);
  registerComponentFactory("FooterNavigation", createPageFooter);

  registerComponentFactory("SearchPage", createSearchPage);
  registerComponentFactory("ProductListPage", createProductListPage);
  registerComponentFactory("SalesCampaignPage", createSalesCampaignPage);

  registerComponentFactory("SchaefflerTopBannerComponent", createSchaefflerTopBannerComponent);

  registerComponentFactory("FreeCapacityPush", () => <FreeCapacityCockpitPage />);
  registerComponentFactory("AffiliateDownloadDatasheetPage", createDataSheetPage);
  registerComponentFactory(
    "SchaefflerFCCGapProductsRecommendationComponent",
    createSchaefflerFccRecommendationComponent,
  );
  registerComponentFactory("CMSPhotoGallery", createCMSComponent);
  registerComponentFactory("CMSPhoto", createCMSComponent);
};
